import { SharedAppApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedAppApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new SharedAppApi(configuration), [configuration]);
};
